import { onSnapshot, query, collection, doc, setDoc } from 'firebase/firestore'
import { db } from 'src/controllers/db'
import { IEntityType, NodeDataT } from 'shared/types'
import { receiveFileTree } from 'src/model/actions'
import store from 'src/model/store'
import { addListener } from 'controllers/listeners'
import { NodeModel } from '@minoru/react-dnd-treeview'

export const dbFetchFileThree = async () => {
  try {
    const q = query(collection(db, 'fileTree'))
    const unsubscribe = onSnapshot(
      q,
      sn => {
        const res: Partial<Record<string, NodeModel<NodeDataT>[]>> = {}
        sn.forEach(doc => {
          const p = doc.data() as { tree: NodeModel<NodeDataT>[] } | undefined
          if (p && p.tree) {
            const eType = doc.id as string
            res[eType] = p.tree
          }
        })
        store.dispatch(receiveFileTree(res))
      },
      err => {
        console.log(`dbFetchCourses error: ${err.message}`)
      }
    )
    addListener('fileTree', unsubscribe)
  } catch (e) {
    console.error('dbFetchCourses error', e)
  }
}

export const dbUpdateFileTree = async (
  entityType: string,
  tree: NodeModel<NodeDataT>[]
) => {
  try {
    console.log('dbUpdateFileTree', entityType, tree)
    const ref = doc(collection(db, 'fileTree'), entityType)
    await setDoc(ref, { tree })
  } catch (e) {
    console.log('dbUpdateFileTree error', e)
  }
}
